/* tslint:disable */
/* eslint-disable */
export enum AcceptedBidState {
  Accepted = 'accepted',
  Withdrawn = 'withdrawn',
  Billed = 'billed',
  Payed = 'payed',
  Credited = 'credited'
}
